import React from 'react';
import { useNavigate } from 'react-router-dom';

export function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white/90 font-sans px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <button
          type="button"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
          className="text-sm text-[#3b82f6] hover:text-[#3b82f6]/80 transition-colors"
        >
          &larr; Back
        </button>

        <h1 className="text-3xl font-bold mt-6 mb-2 text-white">
          FlashTools Terms of Service
        </h1>
        <p className="text-white/50 mb-10">Effective Date: March 19, 2026</p>
        <p className="text-white/50 mb-10">Company: FlashTickets, Inc. (d/b/a FlashTools)</p>

        <Section title="1. Acceptance of Terms">
          <p className="text-white/70">
            By accessing or using FlashTools (the "Platform"), you agree to be bound by these Terms
            of Service ("Terms"). If you do not agree, you may not use the Platform.
          </p>
          <p className="mt-3 text-white/70">
            You represent that you are at least 18 years old and legally capable of entering into
            these Terms.
          </p>
        </Section>

        <Section title="2. Description of Services">
          <p className="text-white/70">
            FlashTools provides analytics, automation, and operational tools related to ticket
            marketplaces and related activities.
          </p>
          <p className="mt-3 text-white/70">
            The Platform may include pricing tools, market data, automation features, and third-party
            integrations. All features are subject to change at any time.
          </p>
        </Section>

        <Section title="3. Use at Your Own Risk">
          <p className="text-white/70">
            All use of FlashTools is at your sole discretion and risk. Outputs and analytics may be
            inaccurate or incomplete. You are solely responsible for decisions made using the
            Platform.
          </p>
        </Section>

        <Section title="4. No Professional Advice">
          <p className="text-white/70">
            FlashTools does not provide legal, financial, tax, or investment advice. All information
            is for informational purposes only.
          </p>
        </Section>

        <Section title="5. No Fiduciary Duty">
          <p className="text-white/70">
            FlashTools does not act as your broker, advisor, agent, or fiduciary. No relationship of
            that kind is created.
          </p>
        </Section>

        <Section title="6. User Responsibilities">
          <p className="text-white/70">
            You agree to use the Platform lawfully, maintain account confidentiality, and avoid
            misuse or fraud.
          </p>
        </Section>

        <Section title="7. Third-Party Services">
          <p className="text-white/70">
            We are not responsible for third-party platforms, integrations, or their data accuracy.
          </p>
        </Section>

        <Section title="8. Intellectual Property">
          <p className="text-white/70">
            All Platform content is owned or licensed by FlashTickets, Inc. You may not copy, modify,
            or reverse engineer it.
          </p>
        </Section>

        <Section title="9. Account Suspension & Termination">
          <p className="text-white/70">
            We may suspend or terminate access at any time for violations or risk.
          </p>
        </Section>

        <Section title="10. Disclaimers">
          <p className="text-white/70">
            The Platform is provided "as is" without warranties of any kind.
          </p>
        </Section>

        <Section title="11. Limitation of Liability">
          <p className="text-white/70">
            FlashTools shall not be liable for indirect or consequential damages. Liability is capped
            at the greater of $100 or fees paid in the past 30 days.
          </p>
        </Section>

        <Section title="12. Indemnification">
          <p className="text-white/70">
            You agree to indemnify FlashTickets, Inc. for claims arising from your use of the
            Platform.
          </p>
        </Section>

        <Section title="13. Arbitration & Class Action Waiver">
          <p className="text-white/70">
            Disputes shall be resolved via binding arbitration in Delaware. No class actions.
          </p>
        </Section>

        <Section title="14. Governing Law">
          <p className="text-white/70">
            These Terms are governed by Delaware law.
          </p>
        </Section>

        <Section title="15. Changes to Terms">
          <p className="text-white/70">
            We may update these Terms at any time.
          </p>
        </Section>

        <Section title="16. Contact Information">
          <p className="text-white/70">
            FlashTickets, Inc.
            <br />
            340 SE 3rd St, Apt 2007
            <br />
            Miami, FL 33131
            <br />
            <a
              href="mailto:legal@flashtickets.fm"
              className="text-[#3b82f6] hover:underline"
            >
              legal@flashtickets.fm
            </a>
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
      {children}
    </section>
  );
}
